import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface PatientVaccineSettingsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface PatientVaccineSettings {
    id: any;
    vaccineChartFlag:string; 
    tenantId: any;
    branchId: any;
    parameters?: PatientVaccineSettingsParameter[];
    links?: any;
}


export abstract class PatientVaccineSettingsData { 

  abstract list(url: string): Observable<PatientVaccineSettings>;
  abstract create(url: string, data: PatientVaccineSettings): Observable<any>;
     
}
